export const MENU_CHANNELS = ["delivery", "mesa", "retirada"] as const;
export type MenuChannel = (typeof MENU_CHANNELS)[number];

const ALIAS: Record<string, MenuChannel> = {
  delivery: "delivery",
  entrega: "delivery",
  mesa: "mesa",
  local: "mesa",
  consumo_no_local: "mesa",
  retirada: "retirada",
  pickup: "retirada",
  balcao: "retirada",
  balcão: "retirada",
};

export function parseVisivelEm(raw: unknown): MenuChannel[] | undefined {
  if (!Array.isArray(raw)) return undefined;
  const out: MenuChannel[] = [];
  for (const value of raw) {
    const key = String(value || "")
      .trim()
      .toLowerCase();
    const channel = ALIAS[key];
    if (channel && !out.includes(channel)) out.push(channel);
  }
  return out;
}

export function resolvedChannels(visivelEm: unknown): MenuChannel[] {
  const parsed = parseVisivelEm(visivelEm);
  return parsed === undefined ? [...MENU_CHANNELS] : parsed;
}

export function allowsMenuChannel(visivelEm: unknown, channel: MenuChannel): boolean {
  const parsed = parseVisivelEm(visivelEm);
  if (parsed === undefined) return true;
  return parsed.includes(channel);
}

export function isVisibleOnChannel(
  product: { visivel_em?: unknown },
  channel: MenuChannel,
  category?: { visivel_em?: unknown }
): boolean {
  return (
    allowsMenuChannel(category?.visivel_em, channel) &&
    allowsMenuChannel(product.visivel_em, channel)
  );
}

export function isSellableOnChannel(
  product: { visivel_em?: unknown; disponivel?: boolean; available?: boolean },
  channel: MenuChannel,
  category?: { visivel_em?: unknown; ativo?: boolean }
): boolean {
  if (product.disponivel === false || product.available === false) return false;
  if (category && category.ativo === false) return false;
  return isVisibleOnChannel(product, channel, category);
}

export function toggleMenuChannel(current: unknown, channel: MenuChannel): MenuChannel[] {
  const now = resolvedChannels(current);
  if (now.includes(channel)) return now.filter((item) => item !== channel);
  return MENU_CHANNELS.filter((item) => now.includes(item) || item === channel);
}

export function assignVisivelEm(
  target: Record<string, unknown>,
  source: { visivel_em?: unknown }
): void {
  const parsed = parseVisivelEm(source.visivel_em);
  if (parsed !== undefined) target.visivel_em = parsed;
}

export function orderTypeToMenuChannel(tipo: unknown): MenuChannel {
  const s = String(tipo || "")
    .trim()
    .toLowerCase();
  if (
    s.includes("retir") ||
    s.includes("pickup") ||
    s.includes("balcao") ||
    s.includes("balcão")
  ) {
    return "retirada";
  }
  if (s.includes("mesa") || s.includes("local") || s.includes("consumo")) {
    return "mesa";
  }
  return "delivery";
}
